import { events } from './utils';
import { OPEN_CONFIRM_EVENT, CLOSE_CONFIRM_EVENT } from './constants';

const ConfirmPlugin = {
  install(Vue) {
    if (this.installed) return;

    this.installed = true;

    const confirm = {
      open(params) {
        return new Promise((resolve, reject) => {
          events.$emit(OPEN_CONFIRM_EVENT, { ...params, resolve, reject });
        });
      },

      close() {
        events.$emit(CLOSE_CONFIRM_EVENT);
      },
    };

    Vue.prototype.$confirm = confirm;
  },
};

export default ConfirmPlugin;
